window.insertAppSelector = require('./appSelect.js');